export const convertDate = (
  dateString: string,
  isTimeNeed: boolean = false,
) => {
  if (!isTimeNeed) {
    const canSplit = dateString.split(" ").length > 2;

    const result = canSplit
      ? dateString.split(" ")[0]
      : new Date(dateString).toLocaleString().split(",")[0];
    return result;
  } else {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    const result = `${day}.${month}.${year} (${hours}:${minutes})`;
    return result;
  }
};
